import { Provider } from "../../Context";
import { Actions } from "./Actions";
import Form from "./Form";

export const AppAutenticacao = () => {
    return (
        <Provider value={Actions()}>
            <div className="App">
                <Form></Form>
            </div>
        </Provider>
    );
}